import styled from 'styled-components';
import { spacing } from '@material-ui/system';
import { Divider as MuiDivider } from '@material-ui/core';

const Divider = styled(MuiDivider)(spacing);

export default Divider;
